import React from 'react';

export const Project = () => (<h1>Project</h1>);
